export default "__VITE_PUBLIC_ASSET__e6915aa7__"